const features = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '全高清画质',
    desc: '支持 1080P 及以上超清画质，每一帧都清晰锐利，带来影院级视觉享受',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '极速加载不缓冲',
    desc: '采用先进的视频加速与 CDN 分发技术，确保高清片源秒开不卡顿',
  },
  {
    id: 3,
    icon: 'ri-database-2-line',
    title: '海量影视资源',
    desc: '涵盖动作、科幻、悬疑、喜剧、动画等全类型影片，片库持续扩充中',
  },
  {
    id: 4,
    icon: 'ri-calendar-check-line',
    title: '每日同步更新',
    desc: '与院线和流媒体同步更新，第一时间上线最新热门大片',
  },
  {
    id: 5,
    icon: 'ri-device-line',
    title: '多端无缝观影',
    desc: '电脑、平板、手机全终端适配，随时随地畅享高清电影',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">为什么选择极速影视</h2>
          <p className="text-sm text-foreground-500">五大核心优势，为你打造极致观影体验</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70 text-center group hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}